<template>
  <div class="body">
    <div class="row justify-between align-center">
      <h2 class="body__heading">{{ $t("order book") }}</h2>
      <div class="body__controls controls">
        <date-picker
          :lang="$t('short lang')"
          :range="true"
          :confirm="true"
          class="controls__item controls__date-picker"
          value-type="format"
          v-model="dateRange"
          @change="handleDatePickerChange"
          @clear="handleDatePickerClear"
          :placeholder="$t('select date range')"
          format="DD.MM.YYYY"
        />
        <select-primary
          class="controls__item"
          :options="formatedStatusSelect"
          @handleSelect="handleStatusSelect"
        />
        <select-primary
          class="controls__item"
          :options="processSelectOptions"
          @handleSelect="handleProcessSelect"
        />
      </div>
    </div>
    <div class="body__table-container preloader-container">
      <div
        v-show="isInstructionsListLoading"
        class="body__table-preloader preloader"
      >
        <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
      </div>
      <table class="body__table table">
        <thead>
          <tr>
            <td class="table__head align-center">
              {{ $t("date of application") }}
            </td>
            <td class="table__head align-center">{{ $t("number") }}</td>
            <td class="table__head align-center">{{ $t("description") }}</td>
            <td class="table__head align-right">{{ $t("quantity") }}</td>
            <td class="table__head align-right">{{ $t("price") }}</td>
            <td class="table__head align-right">{{ $t("sum") }}</td>
            <td class="table__head align-center">{{ $t("currency") }}</td>
            <td class="table__head align-center">{{ $t("status") }}</td>
            <td class="table__head align-center">{{ $t("comments") }}</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="instruction in filteredInstructionsList"
            :key="instruction.ORDER_ID"
          >
            <td class="table__body align-center">
              <p>{{ instruction.ORDER_DATE }}</p>
            </td>
            <td class="table__body align-center">
              <p>{{ instruction.ORDER_NUMBER }}</p>
            </td>
            <td class="table__body align-center">
              <p>
                {{ getTitledString(instruction.ORDER_TYPE) }}
              </p>
              <p>{{ instruction.TICKER }}</p>
              <p>{{ instruction.ISIN }}</p>
            </td>
            <td class="table__body align-right">
              {{ getFormatedQuantity(instruction.QUANTITY) }}
            </td>
            <td class="table__body align-right">
              {{ roundPrice(instruction.PRICE) }}
            </td>
            <td class="table__body align-right">
              {{ getFormatedMoney(instruction.AMOUNT) }}
            </td>
            <td class="table__body align-center">
              {{ instruction.CURRENCY }}
            </td>
            <td class="table__body align-center">
              <p
                :class="
                  instruction.STATUS.toLowerCase() === 'исполнен'
                    ? 'table__body_green'
                    : 'table__body_red'
                "
              >
                {{ getTitledString(instruction.STATUS) }}
              </p>
              <p v-if="instruction.STATUS.toLowerCase() === 'исполнен'">
                {{ instruction.EXECUTE_DATE }}
              </p>
            </td>
            <td class="table__body align-left">
              <p>{{ instruction.COMMENTS }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import accounting from "accounting";
import DatePicker from "vue2-datepicker";
import SelectPrimary from "@/components/ui-kit/SelectPrimary";
import { HalfCircleSpinner } from "epic-spinners";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    "select-primary": SelectPrimary,
    "date-picker": DatePicker,
    spinner: HalfCircleSpinner
  },
  data() {
    return {
      dateRange: [
        moment()
          .subtract(3, "month")
          .format("DD.MM.YYYY"),
        moment().format("DD.MM.YYYY")
      ],
      selectedStatus: "all",
      selectedProcess: "all",
      statusSelectOptions: [
        {
          value: "all",
          text: "Все статусы"
        },
        {
          value: "исполнен",
          text: "Исполнен"
        },
        {
          value: "исполнен частично",
          text: "Исполнен частично"
        },
        {
          value: "в работе",
          text: "В работе"
        },
        {
          value: "не исполнен",
          text: "Не исполнен"
        }
      ],
      processSelectOptions: [
        {
          value: "all",
          text: "Все типы"
        },
        {
          value: "обратное авто РЕПО",
          text: "Обратное авто РЕПО"
        },
        {
          value: "зачисление ЦБ",
          text: "Зачисление ЦБ"
        },
        {
          value: "Покупка",
          text: "Покупка"
        },
        {
          value: "продажа",
          text: "Продажа"
        },
        {
          value: "списание ЦБ",
          text: "Списание ЦБ"
        },
        {
          value: "Приказ на выдачу отчёта",
          text: "Приказ на выдачу отчёта"
        }
      ]
    };
  },
  computed: {
    // Возвращаем массив с вариантами статуса и выбранным статусом
    formatedStatusSelect() {
      return this.statusSelectOptions.map(item => {
        if (item.value === this.selectedStatus) {
          return {
            ...item,
            selected: true
          };
        }
        return item;
      });
    },
    formatedProcessSelect() {
      return this.processSelectOptions.map(item => {
        if (item.value === this.selectedProcess) {
          return {
            ...item,
            selected: true
          };
        }
        return item;
      });
    },
    filteredInstructionsList() {
      // Если пользователь выбрал "Все", возвращаем весь массив
      return this.filterByProcess(
        this.filterByStatus(this.instructionsList, this.selectedStatus),
        this.selectedProcess
      );
    },
    ...mapGetters(["instructionsList", "isInstructionsListLoading"])
  },
  methods: {
    roundPrice(price) {
      if (price == null) {
        return "0";
      }
      var newPrice = price.replace(",", ".");
      newPrice = parseFloat(newPrice).toFixed(4);
      return newPrice;
      //Math.round(price * 100) / 100;
    },
    // TODO: функции filterByProcess и filterByStatus можно объеденить в одну
    // Фильтруем по процессу
    filterByProcess(instructionsList, process) {
      if (process === "all") {
        return instructionsList;
      } else {
        return instructionsList.filter(
          instruction =>
            instruction.ORDER_TYPE.toLowerCase() === process.toLowerCase()
        );
      }
    },
    // Фильтруем по статусу
    filterByStatus(instructionsList, status) {
      if (status === "all") {
        return instructionsList;
      } else {
        return instructionsList.filter(
          instruction =>
            instruction.STATUS.toLowerCase() === status.toLowerCase()
        );
      }
    },
    getFormatedMoney(money) {
      return accounting.formatNumber(money, 2, " ");
    },
    getFormatedQuantity(quantity) {
      return accounting.formatNumber(quantity, 0, " ");
    },
    getTitledString(text) {
      if (text) {
        return text.charAt(0).toUpperCase() + text.substr(1);
      }
      return text;
    },
    getFormatedDateRange(dateRange) {
      return {
        startDate: dateRange[0],
        endDate: dateRange[1]
      };
    },
    handleDatePickerChange(dateRange) {
      // console.log(dateRange);
      this.$store.dispatch("clearInstructions");
      this.$store.dispatch(
        "fetchInstructions",
        this.getFormatedDateRange(dateRange)
      );
      // console.log(dateRange);
    },
    handleDatePickerClear() {
      this.$store.dispatch("fetchInstructions");
    },
    handleStatusSelect(status) {
      this.selectedStatus = status;
    },
    handleProcessSelect(process) {
      this.selectedProcess = process;
    }
  },
  mounted() {
    // this.$store.dispatch("clearInstructions");
    // console.log(this.dateRange);
    this.$store.dispatch(
      "fetchInstructions",
      this.getFormatedDateRange(this.dateRange)
    );
  }
};
</script>

<style scoped>
.body {
  padding: 35px 40px 100px;
}

.body__heading {
  font-weight: normal;
  font-size: 36px;
  color: #222c44;
}

.controls__item:not(:last-child) {
  margin-right: 10px;
}

.body__table-container {
  min-height: 40vh;
}

.controls {
  display: flex;
  align-items: center;
}

.controls__item {
  height: 34px;
  padding: 0 20px;
  max-width: 180px;
  font-size: 15px;
}

.controls__date-picker {
  padding: 0;
}
</style>
